import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  background: {
    background: 'lightgrey',
    padding: '16px',
    gap: '0',
    textAlign: 'center',
  },
  title: {
    fontSize: '16px',
  },
  link: {
    fontSize: '16px',
    color: 'primary',
  },
}))
